import { Link } from 'react-router-dom';

// Public account-deletion instructions page. Exists because Google Play's
// account-deletion policy requires a web URL (submitted in the Data safety
// form) where users can request deletion WITHOUT reinstalling the app; the
// login-gated Profile page alone doesn't read as that to reviewers. Content
// must stay truthful to what deleteUserAccount actually does — update this
// page if that function's scope changes.
const DeleteAccount = () => (
  <div style={{ backgroundColor: '#F7F3EB', minHeight: 'calc(100vh - var(--navbar-height, 125px))', padding: '2rem 1rem', fontFamily: 'Nunito, sans-serif' }}>
    {/* textAlign left: the global .App rule centers text, which strands list
        markers at the indent while their text centers — a visible gulf. */}
    <div style={{ maxWidth: '640px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', padding: '2rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', textAlign: 'left' }}>
      <h1 style={{ fontSize: '1.6rem', color: '#1f2937', marginTop: 0 }}>Delete your PedalxChange account</h1>

      <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
        You can delete your PedalxChange account and its data at any time, from the
        website or the mobile app. Deletion is immediate and cannot be undone.
      </p>

      <h2 style={{ fontSize: '1.15rem', color: '#1f2937' }}>How to delete your account</h2>
      <ol style={{ color: '#4b5563', lineHeight: 1.8, paddingLeft: '1.25rem' }}>
        <li>Log in to your account.</li>
        <li>Open your <strong>Profile</strong> page.</li>
        <li>Scroll to the bottom and choose <strong>Delete Account</strong>, then confirm.</li>
      </ol>
      <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
        Any trades or purchases still in progress must be completed or cancelled
        before the account can be deleted.
      </p>

      <div style={{ textAlign: 'center', margin: '1.5rem 0' }}>
        <Link
          to="/profile"
          style={{ display: 'inline-block', backgroundColor: '#C9A227', color: 'white', fontWeight: 700, borderRadius: '9999px', padding: '12px 32px', textDecoration: 'none', fontSize: '16px' }}
        >
          Log in and go to my Profile
        </Link>
      </div>

      <h2 style={{ fontSize: '1.15rem', color: '#1f2937' }}>What gets deleted</h2>
      <ul style={{ color: '#4b5563', lineHeight: 1.8, paddingLeft: '1.25rem' }}>
        <li>Your profile and account details</li>
        <li>Your pedal listings and Wantlist</li>
        <li>Your offers, matches, and saved matches</li>
        <li>Your sign-in credentials</li>
        <li>Any active membership subscription is cancelled</li>
      </ul>

      <h2 style={{ fontSize: '1.15rem', color: '#1f2937' }}>What is retained</h2>
      <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
        Records of completed transactions and payments are retained by us and our
        payment processor (Stripe) as required for financial, tax, and legal
        compliance and fraud prevention. They are no longer connected to an active
        account.
      </p>

      <h2 style={{ fontSize: '1.15rem', color: '#1f2937' }}>Can&rsquo;t log in?</h2>
      <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
        Email <a href="mailto:contact@pedalxchange.com" style={{ color: '#5A9ECB' }}>contact@pedalxchange.com</a>{' '}
        from the email address on your account and we&rsquo;ll process the deletion
        for you.
      </p>
    </div>
  </div>
);

export default DeleteAccount;
